import { getVuplex } from "./getVuplex"
import type { OutgoingMessage } from "./OutgoingMessage"

export const sendVuplexMessage = async (message: OutgoingMessage) => {
  const vuplex = await getVuplex()
  console.log("Sending Vuplex message", message)
  vuplex.postMessage(message)
}
